<template>
    <div class="auto-complete-input">
        <input type="hidden" :name="name" :value="value" />
        <text-input
            ref="input"
            :name="name + '-auto-complete'"
            :value="search"
            icon="images/icons/arrow-down.svg"
            :is-open="hasFocus"
            @input="onSearchChanged"
            @focus="onFocus"
            @blur="onBlur"
            @enter="onEnterPressed"
            autocomplete="off"
            :placeholder="placeholder"
            v-bind="$attrs"></text-input>
        <div
            class="options"
            v-if="
                hasFocus &&
                filteredOptions &&
                filteredOptions.length > 0 &&
                !loading
            ">
            <template v-for="option in filteredOptions">
                <div class="option" v-on:click="onOptionClick(option)">
                    {{ option.label }}
                </div>
            </template>
        </div>
        <div
            class="options no-options"
            v-if="
                hasFocus &&
                filteredOptions &&
                filteredOptions.length === 0 &&
                !loading &&
                this.search.length > 0 &&
                !hasSelected
            ">
            {{ lblNoOptions }}
        </div>
        <div class="options" v-if="hasFocus && loading">
            <div class="loader">Loading</div>
        </div>
    </div>
</template>

<script>
import TextInput from './TextInput';

export default {
    props: {
        name: String,
        value: String | Number,
        initialSearch: {
            type: String,
            default: '',
        },
        options: {
            // Array of value, label
            type: Array,
            default: [],
        },
        loading: {
            type: Boolean,
            default: false,
        },
        lblNoOptions: {
            type: String,
            default: 'No options found.',
        },
        placeholder: {
            type: String,
            required: false,
        },
    },
    data() {
        return {
            search: this.initialSearch,
            hasFocus: false,
            hasSelected: false,
        };
    },
    computed: {
        filteredOptions() {
            if (this.$listeners && this.$listeners.search && !this.search) {
                return this.options;
            }

            // Filter options by label if no search listener is registered
            return this.options.filter(
                (o) =>
                    o.label.toLowerCase().indexOf(this.search.toLowerCase()) !==
                    -1
            );
        },
    },
    methods: {
        findSearchOptionValue: function () {
            // Auto select if search matches option
            const option = this.options.find(
                (o) => o.label.toLowerCase() === this.search.toLowerCase()
            );
            return option ? option.value : null;
        },
        onSearchChanged(value) {
            this.hasSelected = false;
            this.search = value;

            const optionValue = this.findSearchOptionValue();

            // Set value
            if (optionValue) {
                if (this.$listeners && this.$listeners.input) {
                    this.$emit('input', optionValue);
                } else {
                    this.value = optionValue;
                }
            }

            this.$emit('search', value); // Send back the search value so the container can fetch
        },
        onFocus() {
            this.hasFocus = true;
            this.$emit('focus');
        },
        onBlur() {
            setTimeout(() => {
                this.hasFocus = false;
                const selectedOption = this.options.find(
                    (x) => x.value == this.value
                );
                this.search = selectedOption ? selectedOption.label : '';
                this.$emit('blur', this.value);
            }, 200);
        },
        onOptionClick(option) {
            this.hasSelected = true;

            // Set value
            if (this.$listeners && this.$listeners.input) {
                this.$emit('input', option.value);
            } else {
                this.value = option.value;
            }

            // Set search
            this.search = option.label;
        },
        onEnterPressed() {
            // Select first option
            if (this.filteredOptions && this.filteredOptions.length >= 1) {
                this.onOptionClick(this.filteredOptions[0]);
            }

            // Lose focus
            this.$refs.input.blur();
        },
        focus() {
            this.$refs.input.focus();
        },
        clearSearch() {
            this.search = '';
        },
        updateSearchToValue() {
            if (this.value) {
                const option = this.options.find((x) => x.value == this.value);
                this.search = option ? option.label : '';
            } else {
                this.search = '';
            }
        },
    },
    watch: {
        value() {
            this.updateSearchToValue();
        },
        options() {
            this.updateSearchToValue();
        },
    },
    components: {
        TextInput,
    },
};
</script>
